<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<div>
  <as-split direction="horizontal">
    <as-split-area [size]="40">
      <!-- <app-stock-kline [stklgSrv]="stklgSrv" [stkmaSrv]="stkmaSrv" [stockSrv]="stockSrv" [stockno]="stockNo">

      </app-stock-kline> -->

      <div class="border-2 border-blue-300">
        <!-- <div class="jk-grid-cols-4">
          <app-jkautocomplete #stklg004 label="商品代號" [showClearButton]="true"
            valueExpr="id" displayExpr="name"
            [itemList]="stkmaSrv.idNameList"
            [(value)]="stockNo">
          </app-jkautocomplete>
          <div>
            <app-jkcombobox #stklg002 labelMode="floating" label="資料頻率" [items]="stockSrv.stklg002List"
              displayExpr="name" valueExpr="id" [(value)]="stockSrv.stklg002">
            </app-jkcombobox>
          </div>
          <div>
            <app-jkcombobox #stock_range label="期間" [items]="stockRangeList" displayExpr="name" valueExpr="id"
              [(value)]="stockSrv.stockRange">
            </app-jkcombobox>
          </div>
          <app-candlestick #candlestick [itemList]="candlestickList" [width]="50" [height]="100"></app-candlestick>
        </div> -->
        <app-jkbbchart id="bbchart" #bbchart [itemList]="stklgSrv.itemList()"
          [stockno]="stockNo"
          [scrollbarVisible]="scrollbarVisible" [open]="open" [high]="high" [low]="low" [close]="close" [UBT]="UBT"
          [LBT]="LBT" [X]="X" [sma5]="sma5" [sma20]="sma20" [sma60]="sma60" [barGroupWidth]="barGroupWidth"
          [visualRange]="visualRange">
        </app-jkbbchart>
        <!-- <app-volume-chart #volumechart [itemList]="stklgSrv.itemList">
        </app-volume-chart>
        <app-kd-chart #kdchart [itemList]="stklgSrv.itemList">
        </app-kd-chart>
        <app-macd-chart #macdchart [itemList]="stklgSrv.itemList">
        </app-macd-chart> -->
      </div>
    </as-split-area>
    <as-split-area [size]="60">
      <div class="border-2 border-pink-300">
        <mat-tab-group #masterTabGroup  mat-stretch-tabs="false" mat-align-tabs="start" style="vertical-align: top;">
          <mat-tab label="綜合資訊">
            <mat-toolbar class="flex space-x-1">
              <button class="btn" [class.btn-danger]="true" (click)="doQuery()"><mat-icon>refresh</mat-icon></button>
              <button class="btn" [class.btn-primary]="true" (click)="doCalcRange()">重計range</button>
              <button class="btn" [class.btn-primary]="true" (click)="doCalcOneday()">重計oneday</button>
              <button class="btn" [class.btn-primary]="true" (click)="dostkmeImportStkmj()">選股中心更新群組</button>
              <button class="btn" [class.btn-primary]="true" (click)="doAddGroup('003',stockNo)">加到003群組</button>
              <button class="btn" (click)="doDeleteStkle()">刪今天通知</button>
            </mat-toolbar>
            <!-- <app-stock-quote #jkgridwin [height]="300" [itemList]="stockQuoteList" (afterColumnDefs)="afterColumnDefs($event)"
              (afterGridReadyStockQuote)="afterGridReadyStockQuote($event)" (doubleClick)="agRowDoubleClicked($event)"
              (afterQuery)="stockQuoteAfterQuery($event)">
            </app-stock-quote> -->
            <app-jkgridwin #jkgridwin [height]="300"  (afterColumnDefs)="afterColumnDefs($event)"
              (afterGridReady)="afterGridReadyStockQuote($event)" (doubleClick)="agRowDoubleClicked($event)"
              (afterQuery)="stockQuoteAfterQuery($event)">
            </app-jkgridwin>

            <div class="jk-grid-cols-2">
              <!-- <app-jkgridwin [width]="screenWidth" [height]="400" (click)="agRowClicked($event)" [title]="'股票群組明細'" ariaLabel="股票群組明細"
               (afterGridReady)="afterGridReady($event)">
            </app-jkgridwin> -->
              <app-jkgridwin [width]="screenWidth" label="選股條件結果" [height]="200" ariaLabel="選股條件結果stkmm"
                (afterGridReady)="afterGridReadyStkmm($event)">
              </app-jkgridwin>
              <app-jkgridwin label="通知" [width]="screenWidth" [height]="200" ariaLabel="stkle通知"
                (afterGridReady)="afterGridReadyStkle($event)">
              </app-jkgridwin>
              <app-jkgridwin label="筆記" [width]="screenWidth" [height]="200" ariaLabel="stkwl筆記"
                (afterGridReady)="afterGridReadyStkwl($event)">
              </app-jkgridwin>
              <app-jkgridwin label="交易紀錄" [width]="screenWidth" [height]="200" ariaLabel="stktb交易紀錄"
                (afterGridReady)="afterGridReadyStktb($event)">
              </app-jkgridwin>
              <app-jkgridwin label="財務紀錄" [width]="screenWidth" [height]="200" ariaLabel="stkli財務紀錄"
                (afterGridReady)="afterGridReadyStkli($event)">
              </app-jkgridwin>
              <app-view-market>
              </app-view-market>
              <app-order-stock>

              </app-order-stock>
              <app-future-stock>
              </app-future-stock>
              <app-stock-view02>

              </app-stock-view02>
            </div>
          </mat-tab>
          <mat-tab label="查詢條件">
            <mat-toolbar>
              <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">查詢</button>
              <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doStkmaEdit()">股票基本資料編輯</button>
              <app-jkcheckbox [(value)]="stockSrv.isMQTT" [label]="'使用MQTT'"></app-jkcheckbox>
              <app-jkcheckbox [(value)]="stockSrv.isSTKTM" [label]="'過濾追蹤中心'"></app-jkcheckbox>
            </mat-toolbar>
            <div class="jk-grid-cols-3">
              <div>
                <!-- <app-jkcombobox #stkme001 label="群組" [width]="100" [(value)]="stockSrv.stkme001" (valueChange)="doQuery()"
                [items]="stockSrv.stkmeList">
              </app-jkcombobox> -->
              <app-jkautocomplete #stkme001 label="群組" [showClearButton]="true" [required]="true"
              valueExpr="id" displayExpr="name"
              [itemList]="stkmeSrv.idNameList"
              [(value)]="groupNo">
              </app-jkautocomplete>

                <!-- <app-jkbtnedit #stkme001 label="群組" [showClearButton]="true" [required]="true" maintable="STKME"
                  item="W04" valueExpr="ME001" displayExpr="ME002" (valueChange)="doQuery()"
                  [(value)]="stockSrv.stkme001">
                </app-jkbtnedit> -->

              </div>
              <app-jkdatefield [(value)]="date1">
              </app-jkdatefield>
              <div>
                <app-jknumberedit #topN [title]="'K線筆數'" [width]="50" [required]="true" [(value)]="stockSrv.topN"
                  [showClearButton]="true">
                </app-jknumberedit>
              </div>
              <div>
                <app-jkrange #stklg001 class="jk-range" label="K線日期" [required]="true" [valueA]="stockSrv.date1"
                  [showOpenWinButton]="false" [valueB]="stockSrv.date2">
                </app-jkrange>
              </div>
              <!-- <button class="btn" [class.btn-primary]="true" (click)="doStockQuery()">
                股票報價
              </button> -->
              <!-- <app-jkcombobox #quoteMainItem labelMode="floating" label="資料來源" [items]="quoteMainItemList"
                displayExpr="name" valueExpr="id" [(value)]="quoteMainItemValue">
              </app-jkcombobox> -->
            </div>

          </mat-tab>
          <mat-tab label="技術分析">

            <app-jkgridwin [width]="screenWidth" [height]="400" ariaLabel="技術分析明細"
              (afterQuery)="afterQueryStklg($event)" (afterGridReady)="afterGridReadyStklg($event)">
            </app-jkgridwin>
          </mat-tab>

          <mat-tab label="追蹤股票建立">
            <app-stkpi19 #stkpi19Com>
            </app-stkpi19>
          </mat-tab>
          <mat-tab label="群組建立">
            <app-stkpi13 #stkpi13Com>
            </app-stkpi13>
          </mat-tab>
          <mat-tab #baseData label="網站股票資料">
            <app-stock-view03 [stockno]="this.stockNo">
            </app-stock-view03>
          </mat-tab>


          <mat-tab label="通知">
            <!-- <app-stock-notify [type]="'2'">
          </app-stock-notify> -->
          <app-stkpi20 #stkpi20Com>
          </app-stkpi20>
          </mat-tab>
          <mat-tab label="股票基本">
            <app-stkpi01 #stkpi01Com>
            </app-stkpi01>

          </mat-tab>
          <mat-tab label="LOG">
            <!-- <app-jktextarea [value]="stockSrv.mqtt.getResult()" label="mqtt log"></app-jktextarea> -->
            <mat-divider></mat-divider>
            <div>
              <app-jktextarea [value]="logMessage" label="logMessage"></app-jktextarea>
            </div>
            <div>
              <app-jktextarea [value]="stockSrv.stockMessage" label="stockMessage"></app-jktextarea>
            </div>

          </mat-tab>
        </mat-tab-group>

      </div>
    </as-split-area>
  </as-split>
</div>

